import Device from './Device'

export default class DeviceCollection extends Array {

	constructor (data) {
		super()
		data.forEach(element => {
			this.push(new Device(element))
		})
	}
}



// WEBPACK FOOTER //
// ./src/classes/DeviceCollection.js